import React, { useState, useEffect } from "react";


export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  // Show button after scrolling 300px
  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll to top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {isVisible && (
        <div className="back-to-top" onClick={scrollToTop}>
          {/* Circular Rotating Text */}
          <svg className="circle-text" viewBox="0 0 120 120">
            <defs>
              <path
                id="circlePath"
                d="M60,60 m-50,0 a50,50 0 1,1 100,0 a50,50 0 1,1 -100,0"
              />
            </defs>
            <text>
              <textPath xlinkHref="#circlePath" startOffset="0%">
                ● SCROLL TO EXPLORE ● SCROLL TO EXPLORE ●
              </textPath>
            </text>
          </svg>

          {/* Arrow Icon */}
          <div className="arrow-icon">
            <svg
              width="22"
              height="12"
              viewBox="0 0 22 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21 11L11 1L1 11"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      )}
    </>
  );
}
